<template>
  <v-content v-if="loading">
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <!-- 确认框 -->
    <confirm ref="myConfirm"
             @clickFun="clickFun"></confirm>
    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-row class="rows btn-group">
      <v-btn @click="openAddDialog">添加</v-btn>
      <v-btn @click="doDelete()">删除</v-btn>
    </v-row>

    <v-flex class="table-style">
      <v-data-table v-model="selected"
                    :headers="headers"
                    :items="tableDate"
                    :single-select="singleSelect"
                    item-key="typeId"
                    show-select
                    class="elevation-1">
        <template v-slot:top>
          <v-switch v-model="singleSelect"
                    label="禁止多选"
                    class="pa-3"></v-switch>
        </template>
        <template v-slot:item.note="{ item }">
          <span class="type-note"
                :title="item.note">{{ item.note}}</span>
        </template>
        <template v-slot:item.option="{ item }">
          <v-icon small
                  class="mr-2"
                  @click="openUpdateDialog(item)"
                  title="修改">fa fa-magic</v-icon>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog v-model="upfileDialog"
              width="500">
      <v-card>
        <v-card-text>
          <v-card-title primary-title>上传文件</v-card-title>

          <v-file-input class="in-file"
                        label=" 上传Excel"
                        ref="files"
                        accept=".xls"></v-file-input>

          <v-card-actions>
            <v-btn color="primary"
                   @click="checkData($event)">上传</v-btn>
            <v-btn color="primary"
                   @click="upfileDialog = false">取消</v-btn>

          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>
    <!-- 添加类型弹窗 -->
    <v-dialog v-model="typeDialog"
              width="500">
      <v-card>
        <v-card-text>
          <v-card-title primary-title>{{btnType==1?"添加新类型":"修改类型信息"}}</v-card-title>

          <v-form :model="formType"
                  ref="formType"
                  @keyup.enter.native="handleLogin">
            <v-row>
              <v-card-title class="add-title"
                            primary-title>类型名:</v-card-title>
              <v-text-field class="add-field"
                            name="login"
                            type="text"
                            v-model="formType.typeName"
                            :error="error"
                            :rules="[rules.required]" />
            </v-row>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                 @click="typeDialog = false">取消</v-btn>
          <v-btn color="primary"
                 @click="doClick">{{btnType==1?"添加":"修改"}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>


<script>
import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口

//新添类型对象
const NewType = {
  //类型名
  typeName: "",
  note: "",
}

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      singleSelect: false,
      //添加弹框标识
      typeDialog: false,
      upfileDialog: false,
      //1:添加 2:修改
      btnType: 1,
      formType: {},
      error: false,
      test: [],
      //错误提醒
      rules: {
        required: (value) => !!value || '必填项，不能为空'
      },
      //复选框选中的类型Id
      selected: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'typeId',
        },
        { text: '类别名称', value: 'typeName' },
        { text: ' 备注', value: 'note' },
        { text: '所属内容', value: 'content' },
        { text: '操作', value: 'option', sortable: false },
      ],
      tableDate: [],
    }
  },
  created () {
    this.init();
  },
  mounted () {
    this.$emit("updateNavigationValue", 4)
  },
  methods: {
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("GetProductTypes")
        .then(response => {
          this.tableDate = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.loading = true;
    },

    //打开新添界面
    openAddDialog () {
      this.formType = NewType;
      this.btnType = 1;
      this.typeDialog = true;
    },
    openUpDialog () {

      this.upfileDialog = true;
    },
    doClick () {
      this.btnType == 1 ? this.addType() : this.updateType()
    },

    //新添类型
    addType () {
      this.isLoading = true;
      this.$store.dispatch("AddType", this.formType).then(response => {
        let result = response.data.data;
        let str = "";
        str = result == 200 ? "添加成功!" : "添加失败!";
        this.$refs.myAlert.show(str, {
          type: 'alert'
        })
        this.typeDialog = false;
        this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    },

    //删除
    doDelete () {

      if (this.selected.length >= 1) {
        this.$refs.myConfirm.show("确认删除所选类型吗?", {})

      } else {
        this.$refs.myAlert.show("请选择类型", {
          type: 'alert'
        })
      }

    },


    //确认删除
    clickFun (type) {
      if (type == "clickConfirm") {
        this.isLoading = true;
        for (var i = 0; i < this.selected.length; i++) {
          this.test[i] = this.selected[i].typeId
        }
        this.$store.dispatch("Deletetypeinfo", this.test).then(response => {
          let result = response.data.data;
          let str = "";
          str = result == 200 ? "删除成功!" : "删除失败!";
          this.$refs.myAlert.show(str, {
            type: 'alert'
          })
          this.init();

        })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },

    //打开修改界面
    openUpdateDialog (obj) {
      this.formType = obj;
      this.btnType = 2;
      this.typeDialog = true;
    },
    //修改类型
    updateType () {

      this.$store.dispatch("UpdateType", this.formType).then(response => {
        let result = response.data.data;
        let str = "";
        str = result == 200 ? "修改成功!" : "修改失败!";
        this.$refs.myAlert.show(str, {
          type: 'alert'
        })
        this.typeDialog = false;
        this.init();
      })
        .catch(() => {
          this.isLoading = false;
        });
    },


  }
}
</script>

<style scoped>
.rows {
  margin: 0;
  justify-items: center;
  align-items: center;
}
.btn-group {
  flex: none !important;
  width: 300px;
}
.btn-group >>> .v-btn {
  margin: 5px;
  background: cadetblue !important;
}
.table-style {
  width: 98%;
  height: 680px;
  overflow: auto;
}

.add-title {
  width: 100px;
  flex: none;
}
.add-field {
  width: 300px;
  flex: none;
}
.sh-file {
  width: 100px;
  float: left;
  flex: none;
}
.in-file {
  width: 300px;
  flex: none;
}

.type-note {
  max-width: 400px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>